import { Directive, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, inject } from "@angular/core";
import { Subscription } from 'rxjs';

import { CaseContextRecordsService } from "@app/case-context/services/case-context-records.service";
import {
  InmateOffenseRecord,
  RecordPanelState,
} from "@app/case-context/models/inmate-offense-record.model";

/**
 * Shared load/filter/state plumbing for case-context record panels. Subclasses
 * only declare which records they want via {@link accepts}.
 */
@Directive()
export abstract class CaseContextRecordPanelBase implements OnInit, OnChanges, OnDestroy {
  @Input({ required: true }) incarceratedPersonId!: number;

  records: InmateOffenseRecord[] = [];
  state: RecordPanelState = "loading";

  private readonly records$ = inject(CaseContextRecordsService);
  private request?: Subscription;

  ngOnInit(): void {
    this.load();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["incarceratedPersonId"] && !changes["incarceratedPersonId"].firstChange) {
      this.load();
    }
  }

  protected abstract accepts(record: InmateOffenseRecord): boolean;

  ngOnDestroy(): void { this.request?.unsubscribe(); }

  private load(): void {
    this.request?.unsubscribe();
    this.records = [];
    if (!this.incarceratedPersonId || this.incarceratedPersonId <= 0) {
      this.state = "empty";
      this.records = [];
      return;
    }

    this.state = "loading";
    this.request = this.records$.getByIncarceratedPerson(this.incarceratedPersonId).subscribe({
      next: (records) => {
        this.records = (records ?? []).filter((r) => this.accepts(r));
        this.state = this.records.length === 0 ? "empty" : "ready";
      },
      error: () => {
        this.records = [];
        this.state = "error";
      },
    });
  }
}
